var _symbol, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadshot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "dude-transit",
    viewBox: "0 -25.1 21.25 25.118"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M15.5-4.2l0.75-1.05l1-3.1l3.9-2.65v-0.05 c0.067-0.1,0.1-0.233,0.1-0.4c0-0.2-0.05-0.383-0.15-0.55c-0.167-0.233-0.383-0.35-0.65-0.35l-4.3,1.8l-1.2,1.65l-1.5-3.95 l2.25-5.05l-3.25-6.9c-0.267-0.2-0.633-0.3-1.1-0.3c-0.3,0-0.55,0.15-0.75,0.45c-0.1,0.133-0.15,0.25-0.15,0.35 c0,0.067,0.017,0.15,0.05,0.25c0.033,0.1,0.067,0.184,0.1,0.25l2.55,5.6L10.7-14l-3.05-4.9L0.8-18.7 c-0.367,0.033-0.6,0.184-0.7,0.45c-0.067,0.3-0.1,0.467-0.1,0.5c0,0.5,0.2,0.767,0.6,0.8l5.7,0.15l2.15,5.4l3.1,5.65L9.4-5.6 c-1.367-2-2.1-3.033-2.2-3.1C7.1-8.8,6.95-8.85,6.75-8.85C6.35-8.85,6.1-8.667,6-8.3C5.9-8,5.9-7.8,6-7.7H5.95l2.5,4.4l3.7,0.3 L14-3.5L15.5-4.2z M14.55-2.9c-0.333,0.4-0.45,0.85-0.35,1.35c0.033,0.5,0.25,0.9,0.65,1.2c0.4,0.3,0.85,0.417,1.35,0.35 c0.5-0.067,0.9-0.3,1.2-0.7c0.333-0.4,0.467-0.85,0.4-1.35c-0.066-0.5-0.3-0.9-0.7-1.2c-0.4-0.333-0.85-0.45-1.35-0.35 C15.25-3.533,14.85-3.3,14.55-2.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "topo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.437,
    y: 10.648,
    fill: "#FFFFFF",
    width: 3.149,
    height: 0.861
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.524,
    y: 8.531,
    transform: "matrix(0.7026 -0.7116 0.7116 0.7026 2.1814 23.1408)",
    fill: "#FFFFFF",
    width: 2.5,
    height: 0.859
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.611,
    y: 12.046,
    transform: "matrix(0.7032 -0.711 0.711 0.7032 -0.8341 24.5945)",
    fill: "#FFFFFF",
    width: 0.86,
    height: 2.501
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.869,
    y: 13.128,
    transform: "matrix(0.9028 -0.43 0.43 0.9028 -3.3506 13.0957)",
    fill: "#FFFFFF",
    width: 0.86,
    height: 1.667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.401,
    y: 7.718,
    transform: "matrix(0.5382 -0.8428 0.8428 0.5382 5.7095 26.7163)",
    fill: "#FFFFFF",
    width: 1.667,
    height: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.299,10.939l-2.667-1.046l-7.114,0.018c-0.267-0.822-1.557-2.424-1.92-2.813 c-0.364-0.387-1.284-1.21-2.375-1.742c-1.09-0.534-2.592-0.97-4.044-1.065C7.727,4.196,6.467,4.484,5.571,4.798 C4.674,5.113,3.368,5.839,2.325,7.001c-1.042,1.163-1.671,3.368-1.671,5.887c0,1.769,1.454,5.959,1.345,7.666l-0.292,2.761 c-0.218,0.945-0.289,2.145-0.289,2.145c0.447,0.532,1.925,2.204,3.475,3.366c1.551,1.162,3.658,2.76,5.693,2.737 c2.034-0.023,2.494-0.436,3.365-0.896c0.872-0.461,1.042-0.824,1.17-1.164c0.127-0.339-0.103-0.774-0.249-1.234 c-0.144-0.461,0.024-0.872,0.249-1.042c0.223-0.169,0.574-0.533,0.914-0.823c0.339-0.292,0.702-1.042,0.896-1.599 c0.193-0.558,0.557-2.108,0.774-2.642c0.218-0.532,0.823-1.912,0.993-2.398c0.17-0.484,0.146-1.622-0.072-2.249 c-0.218-0.627-0.218-1.213-0.146-1.966c0.073-0.751,0.508-0.994,0.508-2.378c0-0.31-0.104-0.683-0.304-1.057l5.978-0.026 L27.299,10.939z M8.491,13.291l-1.089,1.236l-1.332-0.97l-0.921,0.631l-0.582-1.696L3.89,12.445l0.073-1.066L2.34,10.893v-0.072 l1.283-0.751L3.212,8.714h1.694l0.243-1.26l0.993,0.437L6.917,6.8l0.485,1.042L8.88,7.527l0.314,1.284l1.891,1.283l-0.944,1.066 l0.944,0.993l-1.43,0.266l-0.12,1.188L8.491,13.291z M12.134,16.448c-0.724-0.062-1.574-0.509-1.84-0.896 c-0.267-0.387-0.363-1.018,0-1.308c0.363-0.29,1.138-0.896,2.325-0.774c1.188,0.121,1.938,0.881,1.889,1.481 c-0.048,0.601-0.461,0.988-0.896,1.183C13.175,16.326,12.422,16.473,12.134,16.448z M17.125,23.06c0,0-0.112,0.294-0.291,0.436 c-0.483,0.388-0.558,0.437-0.848,0.461c-0.291,0.024-0.8,0-1.09,0s-0.727-0.218-1.065-0.389c-0.339-0.169-0.823-0.678-0.921-0.75 c-0.097-0.073-0.351-0.416-0.169-0.557c0.287-0.224,0.727-0.606,1.066-0.679c0.338-0.073,0.762-0.193,1.313-0.193 c0.552,0,1.35-0.049,1.641,0.096c0.291,0.146,0.581,0.484,0.581,0.655C17.342,22.311,17.125,23.06,17.125,23.06z M18.602,14.487 c0.068,0.252-0.28,0.704-0.34,0.969c-0.097,0.436,0.024,0.703,0,0.992c-0.023,0.291-0.217,0.412-0.217,0.412 s-0.218-0.097-0.534-0.218c-0.315-0.121-0.75-0.483-0.75-0.775c0-0.291,0.024-0.702,0.315-0.969c0.291-0.266,0.8-0.604,1.14-0.63 C18.554,14.244,18.516,14.171,18.602,14.487z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadshot);
export default __webpack_public_path__ + "static/media/headshot.e0270cf4599c07ca5ed1b56d343ee3bf.svg";
export { ForwardRef as ReactComponent };